/**
 * NoRowsState component
 * Reusable empty state component for tables with filters
 * Shows contextual messages based on whether filters are active
 */

import { Stack, Typography } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';

import styles from './NoRowsState.module.scss';
import { Icon } from '@/components/ui/Icon';
import { uiIcons } from '@/constants/uiIcons';

interface NoRowsStateProps {
  /**
   * Custom empty state message (when no filters are active)
   */
  emptyMessage?: string;
}

export const NoRowsState = ({ emptyMessage }: NoRowsStateProps) => {
  const { t } = useTranslation('ui');

  return (
    <Stack
      className={styles.Container}
      justifyContent="center"
      alignItems="center"
      data-automation-id="no-rows-state-empty"
    >
      <Icon
        name={uiIcons.state.searchEmpty}
        size="xxLarge"
        color={scssVariables.ColorFog80}
      />
      <Typography color="secondary">
        {emptyMessage || t('emptyState.NoResultsMatchFilters')}
      </Typography>
    </Stack>
  );
};
